import { render, staticRenderFns } from "./CourseCredits.vue?vue&type=template&id=ebdf2944"
import script from "./CourseCredits.vue?vue&type=script&lang=js"
export * from "./CourseCredits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports